<template>
  <transition
    :css="false"
    @leave="leave"
  >
    <f7-block class="margin-top-inverted-45">
      <f7-toolbar
        tabbar
        top
        class="no-shadow padding-top"
      >
        <f7-link
        :class="{'tab-link-active': currentSubTab === 'gisWMS' }"
          tab-link="#tab-gisWMS"
          @click="setTabActive('gisWMS')"
        >
          {{ $t('Searcher.gis.gisWMS.title') }}
        </f7-link>
        <f7-link
          :class="{'tab-link-active': currentSubTab === 'gisTimeDimension'}"
          tab-link="#tab-gisTimeDimension"
          @click="setTabActive('gisTimeDimension')"
        >
          {{ $t('Searcher.gis.gisTimeDimension.title') }}
        </f7-link>
        <f7-link
          :class="{'tab-link-active': currentSubTab === 'gisScanning'}"
          tab-link="#tab-gisScanning"
          @click="setTabActive('gisScanning')"
        >
          {{ $t('Searcher.gis.gisScanning.title') }}
        </f7-link>
      </f7-toolbar>
      <f7-tabs
        animated
        routable
      >
        <f7-tab
          id="tab-gisWMS"
          class="page-content"
          style="padding-top: 50px;"
        >
          <GisWMS v-if="currentSubTab === 'gisWMS'" />
        </f7-tab>
        <f7-tab
          id="tab-gisTimeDimension"
          class="page-content"
          :style="tabStyleDimension"
        >
          <GisTimeDimension v-if="currentSubTab === 'gisTimeDimension'" />
        </f7-tab>
        <f7-tab
          id="tab-gisScanning"
          class="page-content"
          style="padding-top: 50px;"
        >
          <GisScanning v-if="currentSubTab === 'gisScanning'" />
        </f7-tab>
      </f7-tabs>
    </f7-block>
  </transition>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import GisWMS from './gisWMS/index.vue';
import GisTimeDimension from './gisTimeDimension/index.vue';
import GisScanning from './gisScanning/index.vue';

export default {
  name: 'GisSearcher',
  components: {
    GisWMS,
    GisTimeDimension,
    GisScanning,
  },
  computed: {
    tabStyleDimension() {
      const translateStyle = this.currentSubTab === 'gisTimeDimension' && this.isReturning === true
        ? 'transform: translate3d(-100%, 0px, 0px);'
        : '';
      return `padding-top: 50px; ${translateStyle}`;
    },
    ...mapState('Utilities', ['currentSubTab', 'isReturning']),
    ...mapState('Plantation', ['currentPlantation']),
  },
  watch: {
    // Hacemos un watcher para reseteo isReturning y registro eventos GA
    currentSubTab(newValue) {
      const screenNameMap = {
        gisWMS: 'Buscador > Gis > WMS',
        gisTimeDimension: 'Buscador > Gis > Línea Temporal',
        gisScanning: 'Buscador > Gis > Índice Radiométrico',
      };

      const eventMap = {
        gisWMS: {
          name: 'buscador_gis_indice_radiometrico',
          description: 'Evento al entrar en índice radiométrico de buscador/gis',
        },
        gisTimeDimension: {
          name: 'buscador_gis_linea_temporal',
          description: 'Evento cuando se accede a la línea temporal de un sector',
        },
        gisScanning: {
          name: 'buscador_gis_barrido',
          description: 'Evento cuando se accede al barrido de un sector',
        },
      };

      // Lanzar screen_view
      const screenName = screenNameMap[newValue] || 'Buscador > Gis';
      this.$fa.setScreenName(screenName);

      // Lanzar evento personalizado
      if (this.currentPlantation && eventMap[newValue]) {
        const { name, description } = eventMap[newValue];
        this.$fa.logEvent(name, {
          content_type: 'button',
          description,
          sectorId: this.currentPlantation.sectorId,
        }, this.currentPlantation);
      }

      // Resetear la variable de la store isReturning para
      // cuando venga desde la logica del boton volver y solo para las pestañas distintas a linea temporal
      if (newValue === 'gisWMS' || newValue === 'gisScanning') {
        this.setIsReturning(false);
      }
    },
  },
  async beforeMount() {
    if (this.isReturning) {
      // Si estás regresando, activa gisTimeDimension
      this.setCurrentSubTab('gisTimeDimension');
    } else {
      // Si es la primera vez, activa gisWMS
      this.setCurrentSubTab('gisWMS');
    }
  },
  beforeUpdate() {
    this.disableGISWMSMapRequest();
  },
  beforeDestroy() {
    this.leave();
    // Seteamos la variable isReturning cuando abandonamos
    this.setIsReturning(false);
  },
  methods: {
    leave() {
      const timeDimension = document.getElementsByClassName('timecontrol-play')[0];
      if (timeDimension) {
        const timeDimensionClassList = timeDimension.classList;

        if (timeDimensionClassList.contains('pause')) {
          timeDimension.click();
        }
      }
    },
    disableGISWMSMapRequest() {
      if (this.currentSubTab !== 'gisTimeDimension') {
        const timeDimension = document.getElementsByClassName('timecontrol-play')[0];

        if (timeDimension) {
          const timeDimensionClassList = timeDimension.classList;

          if (timeDimensionClassList.contains('pause')) {
            timeDimension.click();
          }
        }
      }
    },
    setTabActive(tabSelected) {
      this.setCurrentSubTab(tabSelected);
    },
    ...mapActions('Utilities', ['setCurrentSubTab', 'setIsReturning']),
  },
};
</script>

<style lang="scss" scoped>
@import './Gis.styles.scss';
</style>
